import { Typography } from "@mui/material";
import { EmptyState } from "layouts";
import { FormattedMessage } from "react-intl";


export default function InvalidIdSplash({ queryId }) {

    return <EmptyState message={<span><FormattedMessage id="SPLASH.INVALID_ID" /> <Typography variant="button" color="error">{queryId}</Typography></span>} />;
}